/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import { Button } from "../../../components";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetRentingProductDetails,
  GetRentingProductOrderHistory,
  GetSingleRentingProductHistory,
} from "../../../utilities/api/stock/rent";
import { toast } from "react-toastify";
import { format } from "date-fns";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { LableFromEnums } from "../../../utilities";
import { CurrentMonth, CurrentYear } from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.stocks;

const ServicesInventoryDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { Enums } = useAppSelector((state) => state.enumsArray);

  const handleInventory = () => {
    navigate("/rent-stock");
  };

  const [data, setData] = useState({
    name: "",
    facilityId: "",
    costPrice: "",
    rentingPrice: "",
    sacCode: "",
    totalQuantity: "",
    igst: "",
    cgst: "",
    sgst: "",
    isActive: "true",
    remarkText: "",
    updatedAt: "",
    availableQuantity: "",
    onRentQuantity: ""
  });

  const [rentedMonth, setRentedMonth] = useState<string>(CurrentMonth);
  const [rentedYear, setRentedYear] = useState<string>(CurrentYear);
  const [historyMonth, setHistoryMonth] = useState<string>(CurrentMonth);
  const [historyYear, setHistoryYear] = useState<string>(CurrentYear);
  const [historyData, setHistoryData] = useState([]);
  const [orderHistory, setOrderHistory] = useState<any[]>([]);

  useEffect(() => {
    GetRentingProductDetails(`${id || ""}`)
      .then((res) => {
        const _data = {
          ...(res?.data || {}),
          igst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "IGST"
          )?.percentage,
          cgst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "CGST"
          )?.percentage,
          sgst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "SGST"
          )?.percentage,
        };
        setData(_data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || getMessage.something_wrong);
      });
  }, []);

  const GetRentOrderHistory = async () => {
    const result = await GetRentingProductOrderHistory(
      id || "",
      rentedYear,
      rentedMonth
    );
    if (result.statusCode === 200) {
      setOrderHistory(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetHistory();
  }, [historyMonth, historyYear]);

  useEffect(() => {
    GetRentOrderHistory();
  }, [rentedMonth, rentedYear]);

  const GetHistory = async () => {
    const result = await GetSingleRentingProductHistory(
      `${id || ""}`,
      historyYear,
      historyMonth
    );
    if (result.statusCode === 200) {
      setHistoryData(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const handleSalesChange = (date: any) => {
    setRentedMonth(date?.format("MM"));
    setRentedYear(date?.format("YYYY"));
  };

  const handleHistoryChange = (date: any) => {
    setHistoryMonth(date?.format("MM"));
    setHistoryYear(date?.format("YYYY"));
  };

  const getPercentValue = (amount: number, percent: number) => {
    return (Number(amount) * Number(percent)) / 100;
  };

  const today = new Date();
  const maxDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const minDate = new Date(2023, 0, 1);

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <Card.Title className="text-start mb-0">
              Services Stock Details
            </Card.Title>
            <hr />
            <Row className="text-start">
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Product Name: <span className="text-info">{data?.name}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Last Inward Quantity:{" "}
                  <span className="text-info">{data?.totalQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  In Service Today: <span className="text-info">{data?.onRentQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Product Value:{" "}
                  <span className="text-info">{data?.costPrice}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Value of overall Stock:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Number(data?.costPrice) * Number(data?.totalQuantity)}
                  </span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Available Quantity:{" "}
                  <span className="text-info">{data?.availableQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Last Inward Date:{" "}
                  <span className="text-info">{data?.updatedAt}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Service charges per 30 minuts:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Number(data?.rentingPrice) +
                      getPercentValue(
                        Number(data?.rentingPrice),
                        Number(data?.igst)
                      )}{" "}
                  </span>{" "}
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="renteddata"
                    className="form-label fw-semibold me-1"
                  >
                    Services History:
                  </label>
                  <DatePicker
                    inputClass="form-control"
                    value={new Date(`${rentedMonth}/01/${rentedYear}`)}
                    onlyMonthPicker
                    format="MM/YYYY"
                    onChange={handleSalesChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder="Select Date"
                    render={<InputIcon className="form-control" />}
                  />
                </div>
                <table className="table table-bordered table-hover table-sm mb-3">
                  <thead>
                    <tr>
                      <th>Rented Date</th>
                      <th>Rented Quantity</th>
                      <th>Rented Duration</th>
                      <th>Rented Price / 30 Min</th>
                      <th>Total Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderHistory.length ? (
                      orderHistory.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td>{item?.createdAt}</td>
                            <td>{item?.quantity}</td>
                            <td>{item?.duration}</td>
                            <td>{item?.rentingPrice}</td>
                            <td>{Math.round(item?.totalAmount)}</td>
                            <td>{LableFromEnums(item?.status, Enums)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={6} className="bg-opacity-75 text-bg-danger">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="viewdata"
                    className="form-label fw-semibold me-1"
                  >
                    Inventory History:
                  </label>
                  <DatePicker
                    inputClass="form-control"
                    value={new Date(`${historyMonth}/01/${historyYear}`)}
                    onlyMonthPicker
                    format="MM/YYYY"
                    onChange={handleHistoryChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder="Select Date"
                    render={<InputIcon className="form-control" />}
                  />
                </div>
                <table className="table table-bordered table-hover table-sm mb-3">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Previous Quantity</th>
                      <th>Current Quantity</th>
                      <th>Previous Cost Price</th>
                      <th>Current Cost Price</th>
                      <th>Previous Rent Price</th>
                      <th>Current Rent Price</th>
                      <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historyData.length ? (
                      historyData.map((_row: any) => (
                        <tr key={_row?.id}>
                          <td>
                            {format(
                              new Date(_row?.createdAt),
                              "dd/MM/yyyy HH:mm"
                            )}
                          </td>
                          <td>{_row?.prevAvailableQuantity}</td>
                          <td
                            style={{
                              color: `${_row?.prevAvailableQuantity <
                                _row?.prevAvailableQuantity +
                                _row?.changeQuantity
                                ? "green"
                                : _row?.prevAvailableQuantity ===
                                  _row?.prevAvailableQuantity +
                                  _row?.changeQuantity
                                  ? "darkorchid"
                                  : "red"
                                }`,
                            }}
                          >
                            {_row?.prevAvailableQuantity + _row?.changeQuantity}
                          </td>
                          <td>{_row?.prevCostPrice}</td>
                          <td
                            style={{
                              color: `${_row?.prevCostPrice <
                                _row?.prevCostPrice + _row?.changeCostPrice
                                ? "green"
                                : _row?.prevCostPrice ===
                                  _row?.prevCostPrice + _row?.changeCostPrice
                                  ? "darkorchid"
                                  : "red"
                                }`,
                            }}
                          >
                            {_row?.prevCostPrice + _row?.changeCostPrice}
                          </td>
                          <td>{_row?.prevRentingPrice}</td>
                          <td
                            style={{
                              color: `${_row?.prevRentingPrice <
                                _row?.prevRentingPrice +
                                _row?.changeRentingPrice
                                ? "green"
                                : _row?.prevRentingPrice ===
                                  _row?.prevRentingPrice +
                                  _row?.changeRentingPrice
                                  ? "darkorchid"
                                  : "red"
                                }`,
                            }}
                          >
                            {_row?.prevRentingPrice + _row?.changeRentingPrice}
                          </td>
                          <td>{_row?.remarkText}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="bg-opacity-75 text-bg-danger">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <Button
                  onClick={handleInventory}
                  type="button"
                  bname="Ok"
                  name="ok"
                  id="ok"
                  className="btn btn-primary rounded-1 "
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { ServicesInventoryDetails };
